module.exports = __webpack_public_path__ + "static/img/sec-top.a8b6e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sec-top.png
// module id = NJOc
// module chunks = 1